<script>
// @ is an alias to /src
import Hero from "@/components/media/Hero.vue";
import Slider from "@/components/media/Slider.vue";
import Gallery from "@/components/media/Gallery.vue";

export default {
  name: "Home",

  data() {
    return {};
  },

  head() {
    return this.$head({
      title: "Marcas",
    });
  },

  computed: {
    brands() {
      return this.$store.state.brands;
    },
  },

  components: {
    Hero,
    Slider,
    Gallery,
  },

  mounted() {
    this.$store.dispatch("opportunities/setOpportunities");
  },
};
</script>


<template>
  <div class="marcas">
    <Hero
      title="Faça parte da transformação <br /> do mundo Fitness"
      :image="'banner.jpg'"
      :search="true"
    />

    <section class="brands">
      <div class="container">
        <div class="brands__box smart">
          <div class="img">
            <div class="logo">
              <img src="@/assets/images/smart_fit/smart-fit-logoc.png" alt="" />
            </div>
            <img class="bg" src="@/assets/images/smart_fit/marca_smart.jpg" alt="" />
          </div>
          <div class="smart content">
            <div class="text">
              <h2>Democratizar o fitness de alto padrão</h2>
              <p>
                A Smart Fit surgiu com o propósito de democratizar o acesso à
                prática de exercícios físicos. E sua inquietude fez com que ao
                longo dos anos ela se transformasse em um grande ecossistema de
                soluções, para que as pessoas possam levar uma vida mais ativa e
                saudável, em qualquer lugar e sempre pagando um preço justo.
              </p>
            </div>
            <div class="btns">
              <a
                href="https://smartfit.com.br/historia-da-rede-smart-fit-academias"
                target="_blanck"
              >
                PARA CONHECER A HISTÓRIA COMPLETA, CLIQUE AQUI.
              </a>
              <router-link  class="bt" :to="{name:'jobs.group',params:{group:'smart-fit'}}"> VER OPORTUNIDADES </router-link>
            </div>
          </div>
        </div>
        <div class="brands__box bioritmo">
          <div class="img">
            <div class="logo">
              <img src="@/assets/images/smart_fit/bioritmow.png" alt="" />
            </div>
            <img class="bg" src="@/assets/images/smart_fit/marca_bio.jpg" alt="" />
          </div>
          <div class="smart content">
            <div class="text">
              <h2>Mais forte. Mais rápido. Desafiando seus limites.</h2>
              <p>
                Bio Ritmo sempre foi sinônimo de pioneirismo, desafio e alta
                qualidade, por isso seu propósito é proporcionar experiências
                exclusivas e diferentes, que entreguem resultados e performance
                para que os clientes possam sempre superar os próprios limites e
                continuarem se desafiando.
              </p>
            </div>
            <div class="btns">
              <a
                href="https://www.bioritmo.com.br/pages/sobre-a-bio-ritmo"
                target="_blanck"
              >
                SAIBA MAIS SOBRE A BIO AQUI.
              </a>
              <router-link class="bt" :to="{name:'jobs.group',params:{group:'bioritmo'}}"> VER OPORTUNIDADES </router-link>
            </div>
          </div>
        </div>
        <div class="brands__box studios">
          <div class="img">
            <div class="logo">
              <h1>
                <i> STUDIOS </i>
              </h1>
            </div>
            <img class="bg" src="@/assets/images/smart_fit/marca_studio.jpg" alt="" />
          </div>
          <div class="smart content">
            <div class="text">
              <h2>Treinos nada convencionais e experiências únicas.</h2>
              <p>
                Os studios ou academias boutique, tem como propósito oferecer
                treinos disruptivos e novas soluções para os apaixonados por
                atividade física, através de espaços modernos, inovadores, com
                atitude e entrega de excelência.
              </p>
            </div>

            <ul
              class="d-flex flex-lg-nowrap flex-wrap justify-content-center align-items-center p-0"
            >
              <li class="d-flex justify-content-center">
                <a href="https://racebootcamp.com.br/" target="_blank">
                <img
                  :src="require(`@/assets/images/smart_fit/${brands[3]}`)"
                  alt=""
                />
                </a>
              </li>

              <li class="d-flex justify-content-center">
                  <a href="https://tonusgym.com.br/" target="_blank">
                <img
                  :src="require(`@/assets/images/smart_fit/${brands[4]}`)"
                  alt=""
                />
                </a>
              </li>

              <li class="d-flex justify-content-center">
                  <a href="https://jabhouse.com.br/" target="_blank">
                <img
                  :src="require(`@/assets/images/smart_fit/${brands[5]}`)"
                  alt=""
                />
                </a>
              </li>
            </ul>

            <div class="btns">
              <router-link class="bt" :to="{name:'jobs.group',params:{group:'studios'}}"> VER OPORTUNIDADES </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.brands {
  margin: 7rem 0px;
  @include media-breakpoint-down(sm) {
    margin: 0px;
  }
  ul {
    margin-top: 3rem;
         @include media-breakpoint-down(sm) {
   flex-wrap: wrap;
   li {
     width: 50% !important;
     border-right: none !important;
   }
  }
    li {
      border-right: 4px solid rgba(122, 120, 120, 0.5);
      display: flex;
      justify-content: center;
      width: calc(100% / 4);
      &:last-of-type {
        border-right: none;
      }
      img {
        height: 150px;
        width: auto;
      }
       @include media-breakpoint-down(md) {
    img {
        height: 80px;
        width: auto;
      }
  }
       @include media-breakpoint-down(sm) {
    img {
        height: auto !important;
        max-height: 180px !important;
        width: 100% !important;
      }
  }
    }
  }
  &__box {
    background: #fcfcfc;
    border-radius: 12px;
    box-shadow: 0px 0px 30px #ccc;
    border-left: 12px solid #90908d;
    margin-top: 4rem;
    &.smart {
      border-color: theme-color(primary);
      a {
        color: theme-color(primary);
      }
    }
    &.bioritmo {
      border-color: #333;
      a {
        color: #000 !important;
      }
           .btns {

      .bt {
        background-color: #333;
        color: #fff !important;
      }
    }
    }
    &.studios {
      .logo {
        h1 {
          font-size: 4.3rem !important;
          color: #fff;
          z-index: 99;
        }
      }
          .btns {
      display: flex;
      justify-content: flex-end;
      .bt {
        background-color: #90908d;
      }
    }
    }
  }
  .content {
    padding: 3rem 3rem 2.5rem 3rem;
    @include media-breakpoint-down(sm) {
      padding: 2rem;
      h2 {
        font-size: 1.5rem !important;
      }
      p {
        font-size: 1.1rem;
        line-height: calc(1.1rem * 1.3);
      }
    }
  }
  p {
    font-size: 1.8rem;
    color: #000;
    line-height: calc(2rem * 1.2);
  }
  .img {
    height: 390px;
    overflow: hidden;
    position: relative;
    width: 100%;
    text-align: center;
    @include media-breakpoint-down(sm) {
      height: auto;
    }
    .logo {
      position: absolute;
      z-index: 99;
      display: block;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      margin: 0 auto;
      img {
        z-index: 99;
        width: 70%;
        max-width: 300px;
      }
    }
    &::after {
      content: "";
      left: 0;
      top: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(#000, 0);
    }
  }
  .btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3rem;
    @include media-breakpoint-down(md) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .bt {
        margin-top: 2rem;
        width: 100%;
        text-align: center;
      }
    }
    @include media-breakpoint-down(sm) {
      a {
        font-size: 1rem;
      }
    }
  }
  a {
    color: theme-color(primary);
    font-size: 1.4rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover {
      text-decoration: underline;
    }
  }
  .bt {
    background-color: theme-color(primary);
    color: #fff !important;
    font-size: 1.4rem;
    padding: 0.5rem 2rem;
    &:hover {
      text-decoration: none;
      opacity: 0.9;
    }
  }
}
</style>
